/**
 * Module: Serum.Date
 * Relative date interval formatting
 */

(function(factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
    define('common/module/date/Serum.Date',factory);
    define('Serum.Date', factory);
  } else {
    factory();
  }
}(function() {

  // Ecmascript 5 strict mode
  'use strict';

  /**
   * @constants
   **/
  var HTML_TEMPLATE = 'mm.dd.yyyy, kl. hh:mm',
    DATE_REGEX = /(.*?)(,\s)/,
    TIME_REGEX = /kl\.\shh.mm/g,
    YESTERDAY = 'i g\u00E5r ',
    TODAY = 'i dag ',
    OFFSET_TEXT_RELATIVE = 'for ',
    OFFSET_TEXT_ABSOLUTE = 'kl. ',
    SECONDS_AGO = 'noen sekunder siden',
    MINUTES_AGO = 'minutter siden',
    MINUTE_AGO = 'ett minutt siden',
    HOURS_AGO = 'timer siden',
    HOUR_AGO = 'én time siden';

  function abbreviateFormattedDate(formattedDate){
    return formattedDate.replace(MINUTES_AGO, 'min siden').replace(MINUTE_AGO, 'ett min siden').replace(SECONDS_AGO, 'noen sek siden');
  }

  /**
   * otherDate is an optional "now"-date used for testing purposes
   *
   * @constructor
   **/
  function constructor(input, otherDate) {
    /**
     * @private
     **/
    var date;

    /**
     * Parse date from iso8601 date format, eg. 2002-03-01T13:00:00Z or 2002-03-01T13:00:00+02:00
     *
     * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
     * © 2011 Colin Snover <http://zetafleet.com>
     * Released under MIT license.
     */
    function parse(iso8601) {
      var numericKeys = [1, 4, 5, 6, 7, 10, 11],
        timestamp,
        struct,
        minutesOffset = 0;
      //              1 YYYY                2 MM       3 DD           4 HH    5 mm       6 ss        7 msec        8 Z 9 ±    10 tzHH    11 tzmm
      if ((struct = /^(\d{4}|[+\-]\d{6})(?:-(\d{2})(?:-(\d{2}))?)?(?:T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?(?:(Z)|([+\-])(\d{2})(?::(\d{2}))?)?)?$/.exec(iso8601))) {
        // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
        for (var i = 0, k;
          (k = numericKeys[i]); ++i) {
          struct[k] = parseInt(struct[k], 10) || 0;
        }

        // allow undefined days and months
        struct[2] = (parseInt(struct[2], 10) || 1) - 1;
        struct[3] = parseInt(struct[3], 10) || 1;

        if (struct[8] !== 'Z' && struct[9] !== undefined) {
          minutesOffset = struct[10] * 60 + struct[11];
          if (struct[9] === '+') {
            minutesOffset = 0 - minutesOffset;
          }
        }
        timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
      } else {
        timestamp = Date.parse ? Date.parse(iso8601) : NaN;
      }

      return new Date(timestamp);
    }

    /**
     * Text formatter
     * @private
     **/
    function formatDays(delta) {
      if (delta.days === 1) {
        return YESTERDAY;
      }
      return TODAY;
    }

    /**
     * Text formatter
     * @private
     **/
    function formatSeconds(delta) { // eslint-disable-line no-unused-vars
      return OFFSET_TEXT_RELATIVE + SECONDS_AGO;
    }
    /**
     * Text formatter
     * @private
     **/
    function formatMinutes(delta) {
      if (delta.mins >= 2) {
        return OFFSET_TEXT_RELATIVE + delta.mins + ' ' + MINUTES_AGO;
      }
      return OFFSET_TEXT_RELATIVE + MINUTE_AGO;
    }

    /**
     * Text formatter
     * @private
     **/
    function formatHours(delta) {
      if (delta.hours >= 2) {
        return OFFSET_TEXT_RELATIVE + delta.hours + ' ' + HOURS_AGO;
      }
      return OFFSET_TEXT_RELATIVE + HOUR_AGO;
    }

    /**
     * Text formatter
     *
     * formatDigits(arg1, arg2, arg3, ..., separator)
     *
     * @private
     **/
    function formatDigits() {
      var html = [],
        length = arguments.length,
        separator = arguments[--length];

      for (var i = 0; i < length; i++) {
        var str = String(arguments[i]);
        if (str.length === 1) {
          str = '0' + str;
        }
        html.push(str);
      }
      return html.join(separator);
    }

    function formatAbsoluteDate(day, month, year){
      var months = ['jan.', 'feb.', 'mars', 'apr.', 'mai', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'des.'];
      return day + '. ' + months[month] + (year ? ' ' + year : '');
    }


    /**
     * calculate diff from now and create delta object
     * @private
     **/
    function diff(date) {
      var MS = 1000,
        SECOND = MS * 1, // eslint-disable-line no-implicit-coercion
        MINUTE = SECOND * 60,
        HOUR = MINUTE * 60,
        DAY = HOUR * 24;

      var diffDate = otherDate || new Date(),
        msDiff = Math.abs(diffDate.getTime() - date.getTime()),
        dateOffset = date.getTimezoneOffset() * MINUTE,
        diffDateOffset = diffDate.getTimezoneOffset() * MINUTE,
        delta = {
          ms: msDiff,
          secs: Math.abs(Math.floor(msDiff / SECOND)),
          mins: Math.abs(Math.floor(msDiff / MINUTE)),
          hours: Math.abs(Math.round(msDiff / HOUR)),
          days: Math.abs(Math.floor((date.getTime() - dateOffset) / DAY) - (Math.floor((diffDate.getTime() - diffDateOffset) / DAY))),
          isSameYear: date.getFullYear() === diffDate.getFullYear()
        };
      if (delta.days === 0 && date.getDay() !== diffDate.getDay()) {
        delta.days++;
      }
      /*
       else if(delta.days === 1 && ((date.getDay() - diffDate.getDay()) !== 1)) {
        delta.days++;
      }*/
      return delta;
    }

    function buildAbsolute(delta){
      var html = HTML_TEMPLATE;
      if (delta.days === 0){
        html = html.replace(DATE_REGEX, TODAY);
      } else if (delta.days === 1){
        html = html.replace(DATE_REGEX, YESTERDAY);
      } else {
        var year = delta.isSameYear ? 0 : date.getFullYear();
        var formattedDate = formatAbsoluteDate(date.getDate(), date.getMonth(), year);
        html = html.replace(DATE_REGEX, formattedDate + ' ');
      }
      return html.replace(TIME_REGEX, OFFSET_TEXT_ABSOLUTE + formatDigits(date.getHours(), date.getMinutes(), ':'));
    }

    /**
     * date string formatter
     * @private
     **/
    function build(delta, isAbsoluteTime) {
      if (isAbsoluteTime) {
        return buildAbsolute(delta);
      }
      var html = HTML_TEMPLATE;
      // test intervals
      if (delta.days === 0) {
        if (delta.hours < 12){
          html = html.replace(DATE_REGEX, '');
        }
        if (delta.mins < 1) {
          html = html.replace(TIME_REGEX, formatSeconds(delta));
        } else if (delta.mins < 60) {
          html = html.replace(TIME_REGEX, formatMinutes(delta));
        } else if (delta.hours < 12) {
          html = html.replace(TIME_REGEX, formatHours(delta));
        } else {
          html = html.replace(DATE_REGEX, formatDays(delta));
          html = html.replace(TIME_REGEX, OFFSET_TEXT_ABSOLUTE + formatDigits(date.getHours(), date.getMinutes(), ':'));
        }
      } else {
        if (delta.days === 1){
          html = html.replace(DATE_REGEX, YESTERDAY);
        } else {
          var year = delta.isSameYear ? 0 : date.getFullYear();
          var formattedDate = formatAbsoluteDate(date.getDate(), date.getMonth(), year);
          html = html.replace(DATE_REGEX, formattedDate + ' ');
        }
        html = html.replace(TIME_REGEX, OFFSET_TEXT_ABSOLUTE + formatDigits(date.getHours(), date.getMinutes(), ':'));
      }
      return html;
    }

    function getDate() {
      return date;
    }

    function getDateline(isAbsoluteTime) {
      return build(diff(date), isAbsoluteTime);
    }

    function getHtml(isAbsoluteTime) {
      var dateline = getDateline(isAbsoluteTime);
      return '<span class="article-dateline__full">' + dateline + '</span><span class="article-dateline__short">' + abbreviateFormattedDate(dateline) + '</span>';
    }

    function getDiffDate() {
      return diff(date);
    }

    // initialise object
    if (input) {
      if (typeof input === 'string') {
        date = parse(input);
      } else if (input instanceof Date) {
        date = input;
      }
    } else {
      date = new Date(0);
    }

    // public accessors (immutable)
    return {
      getDate: getDate,
      getHtml: getHtml,
      getDateline: getDateline,
      getDiffDate: getDiffDate
    };
  }
  // export / expose module
  return constructor;

}));
